import React from 'react';
import styled from 'styled-components';
import Wave from 'react-wavify';
const ThemedDiv = styled.div`
  background: ${({ theme }) => theme.bg1};
  color: ${({ theme }) => theme.textColor};
`;

const Landing = () => {
  return (
    <ThemedDiv>
      <div id='landing'>
        <div
          uk-scrollspy='target: > div > div; cls: uk-animation-fade; delay: 500'
          className='container'
        >
          <div id='landing-msg'>
            <div uk-scrollspy-class='uk-animation-slide-top'>
              <h1>Hello! I am Sabrina</h1>
            </div>
            <div uk-scrollspy-class='uk-animation-slide-bottom'>
              <h3>
                I am a{' '}
                <span
                  style={{
                    color: '#69A1AC',
                    textShadow: '1px 1px #2F3676',
                    letterSpacing: '2px',
                  }}
                >
                  full-stack javascript
                </span>{' '}
                web developer
              </h3>
            </div>
          </div>
        </div>
        {/* <Wave
          fill='#f79902'
          paused={false}
          options={{
            height: 40,
            amplitude: 30,
            speed: 0.2,
            points: 3,
          }}
        /> */}
        <Wave
          mask='url(#mask)'
          fill='#ffc93c'
          options={{
            height: 40,
            amplitude: 30,
            speed: 0.2,
            points: 3,
          }}
        >
          <defs>
            <linearGradient id='gradient' gradientTransform='rotate(90)'>
              <stop offset='0' stopColor='white' />
              <stop offset='0.5' stopColor='black' />
            </linearGradient>
            <mask id='mask'>
              <rect
                x='0'
                y='0'
                width='2000'
                height='200'
                fill='url(#gradient)'
              />
            </mask>
          </defs>
        </Wave>
      </div>
    </ThemedDiv>
  );
};

export default Landing;
